export default function VendorModal({
  modalRef,
  form,
  editId,
  onChange,
  onSubmit,
  submitLoading,
  onCancelEdit,
  validated,
  errors,
}) {
  const country_codes = [
    { code: "+62", label: "🇮🇩 Indonesia" },
    { code: "+60", label: "🇲🇾 Malaysia" },
    { code: "+65", label: "🇸🇬 Singapore" },
    { code: "+66", label: "🇹🇭 Thailand" },
    { code: "+84", label: "🇻🇳 Vietnam" },
    { code: "+63", label: "🇵🇭 Philippines" },
    { code: "+1", label: "🇺🇸 United States" },
    { code: "+44", label: "🇬🇧 United Kingdom" },
    { code: "+61", label: "🇦🇺 Australia" },
    { code: "+81", label: "🇯🇵 Japan" },
    { code: "+82", label: "🇰🇷 South Korea" },
    { code: "+86", label: "🇨🇳 China" },
    { code: "+91", label: "🇮🇳 India" },
    { code: "+92", label: "🇵🇰 Pakistan" },
    { code: "+971", label: "🇦🇪 UAE" },
    { code: "+966", label: "🇸🇦 Saudi Arabia" },
    { code: "+33", label: "🇫🇷 France" },
    { code: "+49", label: "🇩🇪 Germany" },
    { code: "+39", label: "🇮🇹 Italy" },
    { code: "+34", label: "🇪🇸 Spain" },
    { code: "+7", label: "🇷🇺 Russia" },
    { code: "+55", label: "🇧🇷 Brazil" },
    { code: "+52", label: "🇲🇽 Mexico" },
    { code: "+27", label: "🇿🇦 South Africa" },
    { code: "+234", label: "🇳🇬 Nigeria" },
    { code: "+90", label: "🇹🇷 Turkey" },
  ];
  return (
    <form
      noValidate
      className={validated ? "was-validated" : ""}
      onSubmit={onSubmit}
    >
      <div
        className="modal fade"
        id="vendorModal"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby="modalLabel"
        ref={modalRef}
      >
        <div className="modal-dialog modal-lg modal-vendor">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="modalLabel">
                {editId ? "Edit Vendor" : "Tambah Vendor"}
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-md-6 mb-3">
                  <div className="form-floating">
                    <input
                      type="text"
                      name="company_name"
                      value={form.company_name}
                      onChange={onChange}
                      className={`form-control ${
                        errors.company_name ? "is-invalid" : ""
                      }`}
                      placeholder="Nama Perusahaan"
                      required
                    />
                    <label htmlFor="company_name">Nama Perusahaan</label>
                    <div className="invalid-feedback">
                      {errors.company_name || "Nama Perusahaan wajib diisi."}
                    </div>
                  </div>
                </div>
                <div className="col-md-6 mb-3">
                  <div className="form-floating">
                    <input
                      type="text"
                      className={`form-control ${
                        errors.branch ? "is-invalid" : ""
                      }`}
                      id="branch"
                      name="branch"
                      value={form.branch}
                      onChange={onChange}
                      placeholder="Cabang"
                      required
                    />
                    <label htmlFor="branch">Cabang</label>
                    {errors.branch && (
                      <div className="invalid-feedback">
                        {errors.branch || "Cabang wajib diisi."}
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-md-6 mb-3">
                  <div className="form-floating">
                    <input
                      type="text"
                      className={`form-control ${
                        errors.brand ? "is-invalid" : ""
                      }`}
                      id="brand"
                      name="brand"
                      value={form.brand}
                      onChange={onChange}
                      placeholder="Merk"
                      required
                    />
                    <label htmlFor="brand">Merk</label>
                    {errors.brand && (
                      <div className="invalid-feedback">
                        {errors.brand || "Merk wajib diisi."}
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-md-6 mb-3">
                  <div className="form-floating">
                    <input
                      type="text"
                      name="sales_name"
                      value={form.sales_name}
                      onChange={onChange}
                      className={`form-control ${
                        errors.sales_name ? "is-invalid" : ""
                      }`}
                      placeholder="Nama Sales"
                      required
                    />
                    <label htmlFor="sales_name">Nama Sales</label>
                    <div className="invalid-feedback">
                      {errors.sales_name || "Nama Sales wajib diisi."}
                    </div>
                  </div>
                </div>
                <div className="col-md-6 mb-3">
                  <div className="form-floating">
                    <input
                      type="text"
                      name="position"
                      value={form.position}
                      onChange={onChange}
                      className={`form-control ${
                        errors.position ? "is-invalid" : ""
                      }`}
                      placeholder="Jabatan"
                      required
                    />
                    <label htmlFor="position">Jabatan</label>
                    <div className="invalid-feedback">
                      {errors.position || "Jabatan wajib diisi."}
                    </div>
                  </div>
                </div>
                <div className="col-md-6 mb-3">
                  <label className="form-label">No HP / Telp</label>
                  <div className="input-group">
                    <select
                      className="form-select"
                      name="country_code"
                      value={form.country_code}
                      onChange={onChange}
                      style={{ maxWidth: "140px" }}
                    >
                      {country_codes.map((c) => (
                        <option key={c.code} value={c.code}>
                          {c.label} {c.code}
                        </option>
                      ))}
                    </select>
                    <input
                      type="text"
                      name="phone"
                      value={form.phone}
                      onChange={onChange}
                      className={`form-control ${
                        errors.phone ? "is-invalid" : ""
                      }`}
                      placeholder="8123456789"
                      required
                    />
                    <div className="invalid-feedback">
                      {errors.phone || "No HP / Telp wajib diisi."}
                    </div>
                  </div>
                </div>
                <div className="col-md-6 mb-3">
                  <div className="form-floating">
                    <input
                      type="email"
                      name="email"
                      value={form.email}
                      onChange={onChange}
                      className={`form-control ${
                        errors.email ? "is-invalid" : ""
                      }`}
                      placeholder="Email"
                      required
                    />
                    <label htmlFor="email">Email</label>
                    <div className="invalid-feedback">
                      {errors.email || "Email wajib diisi."}
                    </div>
                  </div>
                </div>
                <div className="col-md-6 mb-3">
                  <div className="form-floating">
                    <input
                      type="text"
                      name="product_type"
                      value={form.product_type}
                      onChange={onChange}
                      className={`form-control ${
                        errors.product_type ? "is-invalid" : ""
                      }`}
                      placeholder="Tipe Barang"
                      required
                    />
                    <label htmlFor="product_type">Tipe Barang</label>
                    <div className="invalid-feedback">
                      {errors.product_type || "Tipe Barang wajib diisi."}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              {editId && (
                <button
                  type="button"
                  className="btn btn-secondary me-auto"
                  onClick={onCancelEdit}
                >
                  Batal Edit
                </button>
              )}
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
              <button
                type="submit"
                className="btn btn-primary"
                disabled={submitLoading}
              >
                {submitLoading ? "Memproses..." : editId ? "Update" : "Tambah"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
}
